import { render, staticRenderFns } from "./AddProjectMemberDialog.vue?vue&type=template&id=1f9f799a&scoped=true&"
import script from "./AddProjectMemberDialog.vue?vue&type=script&lang=js&"
export * from "./AddProjectMemberDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddProjectMemberDialog.vue?vue&type=style&index=0&id=1f9f799a&prod&lang=scss&scoped=true&"
import style1 from "./AddProjectMemberDialog.vue?vue&type=style&index=1&id=1f9f799a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9f799a",
  null
  
)

export default component.exports